import './App.css';
import React from 'react';
import MainPage from './MainPage';

let hotelmap=new Map();
hotelmap.set("hgrez","https://gondola.ozsnow.com");
hotelmap.set("hmrez", "https://madarao.ozsnow.com");
hotelmap.set("rqrez","https://reavers.ozsnow.com");
hotelmap.set("olrez","https://owashi.ozsnow.com");
hotelmap.set("svrez","https://snowyvalley.ozsnow.com");

function App() {
    const [response, setResponse] = React.useState();
    const [daterange,setDaterange]=React.useState();
    const [blockdate, setBlockDate] = React.useState();
    const [Itemblockdate, setItemblockdate] = React.useState();
    let refresh=false;
    React.useEffect( () => {
        async function fetchData() {
            const windowUrl = window.location.search;
            const params = new URLSearchParams(windowUrl)
            const hotel=params.get('hotel');
            const hotelCode=params.get('hotelCode')
            if (hotelmap.has(hotel))  {
                console.log("here: "  + hotel);
                console.log("here, " + hotelmap[hotel]);
                const res = await fetch(hotelmap.get(hotel)+'/hire/items/load?hotel=' + hotelCode);
                if (res!=null){
                    const json = await res.json();
                    setResponse(json);
                    refresh=true;
                }
            }
            // const res = await fetch('https://booking.ozsnowadventures.com.au/'+hotel+'/hire/items/load');
            // const res = await fetch('https://booking-old.ozsnowadventures.com.au/'+hotel+'/cusitems/load?hotel='+hotelCode);
        }
        async function fetchData2() {
            const windowUrl = window.location.search;
            const params = new URLSearchParams(windowUrl)
            const hotel=params.get('hotel');
            const hotelCode=params.get('hotelCode')
            if (hotelmap.has(hotel))  {
                const res = await fetch(hotelmap.get(hotel)+'/hire/items/dates?hotel=' + hotelCode);
                if (res!=null){
                    const json = await res.json();
                    setDaterange(json);
                    console.log(json);
                    refresh=true;
                }
            }
            // const res = await fetch('https://booking.ozsnowadventures.com.au/'+hotel+'/hire/items/dates?hotel='+hotelCode);
            // const res = await fetch('https://booking-old.ozsnowadventures.com.au/'+hotel+'/cusitems/load?hotel='+hotelCode);

        }

        async function fetchData3() {
            const windowUrl = window.location.search;
            const params = new URLSearchParams(windowUrl)
            const hotel=params.get('hotel');
            const hotelCode=params.get('hotelCode')
            if (hotelmap.has(hotel))  {
                const res = await fetch(hotelmap.get(hotel)+'/hire/items/blockdate?hotel=' + hotelCode);
                if (res!=null){
                    const json = await res.json();
                    setBlockDate(json);
                    refresh=true;
                }
            }
        }

        async function fetchData4() {
            const windowUrl = window.location.search;
            const params = new URLSearchParams(windowUrl)
            const hotel=params.get('hotel');
            const hotelCode=params.get('hotelCode')
            if (hotelmap.has(hotel))  {
                const res = await fetch(hotelmap.get(hotel)+'/hire/items/Itemblockdate?hotel=' + hotelCode);
                if (res!=null){
                    const json = await res.json();
                    setItemblockdate(json);
                    refresh=true;
                }
            }
        }
        fetchData().then(fetchData2()).then(fetchData3).then(fetchData4);
    }, [refresh])

    return (
        <div>
            {response && daterange && blockdate && Itemblockdate ? <MainPage response={response} daterange={daterange} blockdate={blockdate} itemblockdate={Itemblockdate}/> : "No response from server"}
        </div>

    );
}

export default App;
